import { MobileOutlined, UserOutlined, UserAddOutlined, CalculatorOutlined, QrcodeOutlined, FileTextOutlined, TeamOutlined, ReconciliationOutlined, DashboardOutlined } from '@ant-design/icons';
import { ReactNode } from 'react';
import { FaRegCreditCard } from 'react-icons/fa';
import { IoSettingsOutline } from 'react-icons/io5';
import { MdOutlineVerifiedUser, MdSupportAgent } from 'react-icons/md';
import { RiGroupLine, RiBankCard2Line, RiScales2Fill, RiCalendarCheckLine } from 'react-icons/ri';
import { GiTakeMyMoney } from 'react-icons/gi';
import { TbReportAnalytics } from 'react-icons/tb';

export type MenuOption = {
	name: string;
	path: string | null;
	icon: ReactNode;
	children?: { name: string; path: string }[];
	roles: string[];
};

export const mainFeatures: MenuOption[] = [
	{
		name: 'Users',
		path: '/admin/users',
		icon: <UserOutlined />,
		roles: ['super_admin', 'support_admin', 'support', 'admin'],
	},
	{
		name: 'Devices',
		path: '/admin/devices',
		icon: <MobileOutlined />,
		roles: ['super_admin', 'support_admin', 'support', 'admin'],
	},
	{
		name: 'Installments',
		path: '/admin/installments',
		icon: <RiCalendarCheckLine />,
		roles: ['super_admin', 'support_admin', 'support', 'admin'],
	},
	{
		name: 'Transactions',
		path: '/admin/transactions',
		icon: <FaRegCreditCard />,
		roles: ['super_admin', 'support_admin', 'support', 'admin'],
	},
	{
		name: 'Retailers',
		path: '/admin/retailers',
		icon: <RiGroupLine />,
		roles: ['super_admin', 'support_admin', 'admin'],
	},
	{
		name: 'Field Sales',
		path: null,
		icon: <MdSupportAgent />,
		roles: ['super_admin', 'support_admin', 'admin'],
		children: [
			{ name: 'Team', path: '/admin/field/team' },
			{ name: 'Activity', path: '/admin/field/activity' },
			{ name: 'Commissions', path: '/admin/field/commissions' },
			{ name: 'Retailer Submissions', path: '/admin/field/retailer-applications' },
			{ name: 'Claims Review', path: '/admin/field/claims' },
		],
	},
	{
		name: 'Payouts',
		path: '/admin/payouts',
		icon: <GiTakeMyMoney />,
		roles: ['super_admin', 'support_admin', 'admin'],
	},
	{
		name: 'Recovered Devices',
		path: '/admin/recovered-devices',
		icon: <MobileOutlined />,
		roles: ['super_admin', 'support_admin', 'admin'],
	},
	{
		name: 'Written Off',
		path: '/admin/reports/written-off',
		icon: <TbReportAnalytics />,
		roles: ['super_admin'],
	},
	{
		name: 'Reports',
		path: '/admin/reports',
		icon: <TbReportAnalytics />,
		roles: ['super_admin'],
	},
	{
		name: 'Agent Tracker',
		path: '/admin/agent-overdue-tracker',
		icon: <MdSupportAgent />,
		roles: ['super_admin', 'support_admin', 'support', 'admin'],
	},
	{
		name: 'Verif. Tracker',
		path: '/admin/verification-tracker',
		icon: <MdOutlineVerifiedUser />,
		roles: ['super_admin', 'support_admin', 'support', 'admin'],
	},
	{
		name: 'Reports',
		path: '/insurance/reports',
		icon: <TbReportAnalytics />,
		roles: ['insurance'],
	},
	{
		name: 'Admin Logs',
		path: '/admin/admin-logs',
		icon: <FileTextOutlined />,
		roles: ['super_admin'],
	},
];

export const superAdminSettings: MenuOption[] = [
	{
		name: 'Agent Earning Rates',
		path: '/admin/field/earning-rates',
		icon: <GiTakeMyMoney />,
		roles: ['super_admin'],
	},
	{
		name: 'Config',
		path: '/admin/config',
		icon: <IoSettingsOutline />,
		roles: ['super_admin'],
	},
	{
		name: 'Create Admin',
		path: '/admin/create-admin',
		icon: <UserAddOutlined />,
		roles: ['super_admin'],
	},
	{
		name: 'Manage Admins',
		path: '/admin/manage-admins',
		icon: <TeamOutlined />,
		roles: ['super_admin'],
	},
	{
		name: 'Widget Tokens',
		path: '/admin/widget-tokens',
		icon: <DashboardOutlined />,
		roles: ['super_admin'],
	},
	{
		name: 'Manage Devices',
		path: '/admin/manage-devices',
		icon: <MobileOutlined />,
		roles: ['super_admin', 'support_admin'],
	},
	{
		name: 'For Release',
		path: '/admin/for-release',
		icon: <MobileOutlined />,
		roles: ['super_admin', 'support_admin'],
	},
	{
		name: 'Reconciliation',
		path: '/admin/reconciliation',
		icon: <ReconciliationOutlined />,
		roles: ['super_admin'],
	},
];

export const retailerFeatures: MenuOption[] = [
	{
		name: 'Devices',
		path: '/retailer/devices',
		icon: <MobileOutlined />,
		roles: ['admin'],
	},
	{
		name: 'Withdrawals',
		path: '/retailer/withdrawals',
		icon: <RiBankCard2Line />,
		roles: ['admin'],
	},
	{
		name: 'Payment Accounts',
		path: '/retailer/payment-accounts',
		icon: <RiScales2Fill />,
		roles: ['admin'],
	},
];

export const resourcesMenu: MenuOption[] = [
	{
		name: 'Calculator',
		path: '/calculator',
		icon: <CalculatorOutlined />,
		roles: ['super_admin', 'support_admin', 'support', 'admin'],
	},
	{
		name: 'QR Code',
		path: '/qr-code',
		icon: <QrcodeOutlined />,
		roles: ['super_admin', 'support_admin', 'support', 'admin'],
	},
];
